import { render, staticRenderFns } from "./GdprSimple.vue?vue&type=template&id=d0c3878e&scoped=true&"
import script from "./GdprSimple.vue?vue&type=script&lang=ts&"
export * from "./GdprSimple.vue?vue&type=script&lang=ts&"
import style0 from "./GdprSimple.vue?vue&type=style&index=0&id=d0c3878e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c3878e",
  null
  
)

export default component.exports